import {Injectable} from '@angular/core';
import {BillingRequest} from '../../models/accounting/billing-request';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';

@Injectable({
  providedIn: 'root'
})
export class BillingRequestService extends AbstractModelService<BillingRequest> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/billing-request', BillingRequest);
  }
}
